<template>
	<div v-if="headingImage" ref="header" :class="{ subpage: !route.name.startsWith('index') }">
		<div class="hero-image" :class="{ 'has-video': embedcode }">
			<slot name="heroContent" />
			<div v-if="embedcode" class="video-foreground">
				<div>
					<iframe
						:src="`${embedcode}?loop=1&muted=1&badge=0&autoplay=1&controls=0&autopause=0&player_id=0`"
						frameborder="0"
						allow="autoplay; fullscreen; picture-in-picture"
						allowfullscreen
						title="Ibis Tilburg"
					/>
				</div>
			</div>
			<picture v-else-if="headingImage.image">
				<source
					v-if="headingImage.imagePortraitWebp"
					:srcset="headingImage.imagePortraitWebp"
					type="image/webp"
					media="(max-width: 500px)"
				/>
				<source
					v-if="headingImage.imagePortrait"
					:srcset="headingImage.imagePortrait"
					media="(max-width: 500px)"
				/>
				<source :srcset="headingImage.imageWebp" type="image/webp" />
				<source :srcset="headingImage.image" />
				<img class="slider-image" :src="headingImage.image" :alt="headingImage.imageAlt" />
			</picture>
			<a v-if="route.name.startsWith('index')" class="scroll-down smooth-scroll" @click="scrollDown()" />
		</div>
	</div>
</template>

<script setup>
const route = useRoute();

const header = ref(null);
const scrollDown = () => {
	const scrollHeight = header.value.clientHeight;
	window.scroll({
		top: scrollHeight,
		left: 0,
		behavior: 'smooth',
	});
};

defineProps({
	headingImage: { type: Object, default: () => {} },
	embedcode: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.video-foreground {
	position: absolute;
	top: 0;
	left: -150%;
	width: 400%;
	height: 130%;

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 2;
	}
}

.hero-image {
	width: 100%;
	height: 100vh;
	position: relative;
	overflow: hidden;
}

.hero-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.subpage .hero-image {
	height: 50vh;

	iframe {
		width: 140%;
		height: 140%;
		inset: -20%;
	}

	&.has-video {
		height: 72vh;
	}
}

.hero-image::before {
	content: '';
	z-index: 2;
	position: absolute;
	display: block;
	inset: 0;
	background: rgb(0 0 0 / 30%);
}

.scroll-down {
	position: absolute;
	cursor: pointer;
	bottom: 40px;
	left: 0;
	right: 0;
	margin: 0 auto;
	background: url('~/assets/images/icon-scroll-down.png') no-repeat center center;
	width: 59px;
	height: 59px;
	background-size: 59px;
	z-index: 2;
}

@media (max-width: 1080px) {
	.video-foreground {
		height: 100%;
	}
}

@media (max-width: 680px) {
	.scroll-down {
		display: none;
	}
}

@media (max-width: 500px) {
	.video-foreground {
		width: 470%;
	}
}
</style>
